import { Textbox } from 'fabric';

export interface AutoFitConfig {
  minFontSize: number;
  maxFontSize: number;
  maxHeight: number;
  /** Round the result down to a multiple of this. */
  snapTo?: number;
  /** Defaults to 8 (sub-pixel precision). */
  iterations?: number;
}

const DEFAULT_ITERATIONS = 8;

/** Largest font-size in [min, max] that fits the wrapped text in `maxHeight`. Mutates the Textbox. */
export function autoFitTextbox(textbox: Textbox, cfg: AutoFitConfig): number {
  const iterations = cfg.iterations ?? DEFAULT_ITERATIONS;
  let lo = cfg.minFontSize;
  let hi = cfg.maxFontSize;
  let best = lo;

  if (fits(textbox, hi, cfg.maxHeight)) {
    best = hi;
  } else {
    for (let i = 0; i < iterations; i++) {
      const mid = (lo + hi) / 2;
      if (fits(textbox, mid, cfg.maxHeight)) {
        best = mid;
        lo = mid;
      } else {
        hi = mid;
      }
    }
  }

  const snapped = cfg.snapTo && cfg.snapTo > 0 ? Math.floor(best / cfg.snapTo) * cfg.snapTo : Math.floor(best);
  const final = Math.max(cfg.minFontSize, snapped);

  textbox.set('fontSize', final);
  textbox.initDimensions();
  return final;
}

function fits(textbox: Textbox, fontSize: number, maxHeight: number): boolean {
  textbox.set('fontSize', fontSize);
  textbox.initDimensions();
  return textbox.height <= maxHeight;
}
